import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_DEFAULT_PATH } from '../../config';
import { GuardProps } from '../../types/auth';
import { useAuth } from '../../auth/useAuth';
import { AuthProgress } from './AuthProgress';

const GuestGuard: FC<GuardProps> = ({ children }: GuardProps) => {
	const auth = useAuth();
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		if (!auth.isLoading && auth.isSignedIn) {
			navigate(location.state?.from ? location.state?.from : APP_DEFAULT_PATH, {
				state: {
					from: '',
				},
				replace: true,
			});
		}
	}, [auth, navigate, location]);

	// NOTE: we show guest until auth has signed in and loaded
	const pass = !auth.isLoading && !auth.isSignedIn;

	return pass ? children : <AuthProgress />;
};

export default GuestGuard;
